import { FrameLifecycleService } from 'common/services/frame-lifecycle.service';
import { sendSupplyMonitoringEvent } from '../../supply-monitoring-events/supply-monitoring-events.service';
import { reaction } from '../../utils/preact-utils';
import { RootStore } from '../root.store';

export class FrameLifecycleHandler {
  constructor() {
    this.handle();
  }

  handle() {
    const frameLifecycleService = new FrameLifecycleService(
      sendSupplyMonitoringEvent
    );
    frameLifecycleService.listen();
    const destroyFrameLifecycleHandler = reaction(
      () => RootStore.getInstance().videoStore.isVideoCompleted.value,
      isVideoCompleted => {
        if (isVideoCompleted) {
          frameLifecycleService.destroy();
          destroyFrameLifecycleHandler();
        }
      }
    );
  }
}
